type ShareSupport = {
  share?: (data: ShareData) => Promise<void>;
  clipboard?: {writeText: (text: string) => Promise<void>};
};

export function friendInviteLinks(data: {url: string; text: string}) {
  const message = `${data.text}\n\n${data.url}`;
  return {
    email: `mailto:?subject=${encodeURIComponent('Can you beat my Scam Rush score?')}&body=${encodeURIComponent(message)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(message)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(data.url)}&text=${encodeURIComponent(data.text)}`,
  };
}

export async function shareScore(
  support: ShareSupport,
  data: ShareData & {url: string},
  copyOnly = false,
): Promise<string> {
  if (!copyOnly && support.share) {
    try {
      await support.share(data);
      return 'Share sheet closed.';
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') return '';
      // Unsupported or denied sharing can still use the copy fallback.
    }
  }
  try {
    if (!support.clipboard) return data.url;
    await support.clipboard.writeText(data.url);
    return 'Link copied.';
  } catch {
    return data.url;
  }
}
